/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';

import { Selector, StateContext, Action, State } from '@ngxs/store';
import { CalculatedPrice } from 'rest-client';

import {
  SetCalculatedPriceAction,
  RemoveCalculatedPriceAction,
  SetAbsuidAction,
  RemoveAbsuidAction,
  SetProductAvailabilityAction,
  RemoveAllProductsAvailability,
  RemoveProductAvailability,
  SetTestParamsAction,
  RemoveTestParamsAction,
  SetCarServicesAction,
} from './calculated-price.actions';
import {
  AbsuidStateModel,
  CalculatedPriceStateModel,
  CarServicesStateModel,
  ProductAvailabity,
  ProductsAvailabilityState,
  TestParamsStateModel,
} from './calculated-price.model';

const INITIAL_STATE: CalculatedPriceStateModel = {
  calculatedPricesArray: null,
};

@State<CalculatedPriceStateModel>({
  name: 'calculatedPrice',
  defaults: INITIAL_STATE,
})
@Injectable()
export class CalculatedPriceState {
  @Selector()
  static calculatedPriceData(
    state: CalculatedPriceStateModel
  ): CalculatedPriceStateModel {
    return state;
  }

  @Selector()
  static productsAvailability(
    state: ProductsAvailabilityState
  ): ProductAvailabity[] {
    return state.productsAvailability;
  }

  @Selector()
  static absuid(state: AbsuidStateModel): string {
    return state.absuid;
  }

  @Selector()
  static carServices(state: CarServicesStateModel): string {
    return state.carServices;
  }

  @Selector()
  static testParams(state: TestParamsStateModel): TestParamsStateModel {
    return {
      step: state.step,
      experiment: state.experiment,
      screenResolution: state.screenResolution,
    };
  }

  @Action(SetCalculatedPriceAction)
  SetCalculatedPriceAction(
    ctx: StateContext<CalculatedPriceStateModel>,
    action: SetCalculatedPriceAction
  ): void {
    const state = ctx.getState();
    let newStateFiltered: CalculatedPrice[] = [];

    if (state?.calculatedPricesArray && state.calculatedPricesArray.length) {
      newStateFiltered = state?.calculatedPricesArray?.filter(
        (calculated: CalculatedPrice) => {
          return (
            calculated.offer.productId !==
            action.calculatedPrice.offer.productId
          );
        }
      );
    }

    const calculatedPricesArray = newStateFiltered.length
      ? [...newStateFiltered, action.calculatedPrice]
      : [action.calculatedPrice];

    ctx.patchState({
      calculatedPricesArray: calculatedPricesArray,
    });
  }

  @Action(RemoveCalculatedPriceAction)
  RemoveCalculatedPriceAction(
    ctx: StateContext<CalculatedPriceStateModel>
  ): void {
    ctx.patchState({
      calculatedPricesArray: INITIAL_STATE.calculatedPricesArray,
    });
  }

  @Action(SetAbsuidAction)
  setAbsuidAction(
    ctx: StateContext<AbsuidStateModel>,
    action: SetAbsuidAction
  ): void {
    const state = ctx.getState();
    const savedTimestamp = state?.absuidTimestamp;
    let expiredTimestamp = false;

    if (action.isParam) {
      ctx.patchState({ absuidTimestamp: new Date() });
      ctx.patchState({ absuid: action.absuid });
    } else {

      if (savedTimestamp)
        expiredTimestamp = this.calculateDiffDate(savedTimestamp);

      if (!state?.absuid || expiredTimestamp) {
        ctx.patchState({ absuidTimestamp: new Date() });
        ctx.patchState({ absuid: action.absuid });
      }
    }
  }

  @Action(SetTestParamsAction)
  setTestParamsAction(
    ctx: StateContext<TestParamsStateModel>,
    action: SetTestParamsAction
  ): void {
    if (action.step) {
      ctx.patchState({ step: action.step });
    }
    if (action.experiment) {
      ctx.patchState({ experiment: action.experiment });
    }
    if (action.screenResolution) {
      ctx.patchState({ screenResolution: action.screenResolution });
    }
  }

  calculateDiffDate(date: Date): boolean {
    const now = new Date();
    const _date = new Date(date);
    const milliseconds = Math.abs(now.getTime() - _date.getTime());
    const hours = milliseconds / 36e5;
    return hours > 1 ? true : false;
  }

  @Action(RemoveAbsuidAction)
  removeAbsuidAction(ctx: StateContext<AbsuidStateModel>): void {
    ctx.patchState({
      absuid: null,
      absuidTimestamp: null,
    });
  }

  @Action(RemoveTestParamsAction)
  removeTestParamsAction(ctx: StateContext<TestParamsStateModel>): void {
    ctx.patchState({
      step: null,
      experiment: null,
      screenResolution: null,
    });
  }

  @Action(SetProductAvailabilityAction)
  setProductAvailabilityAction(
    ctx: StateContext<ProductsAvailabilityState>,
    action: SetProductAvailabilityAction
  ): void {
    const state = ctx.getState();
    let newProductObj: ProductAvailabity[] = [];
    let matchID = null;

    if (state.productsAvailability) {
      newProductObj = [...state.productsAvailability];
      matchID = state.productsAvailability?.filter(
        (product: ProductAvailabity) =>
          product.productId === action.product.productId
      );
    }

    if (matchID && matchID.length > 0) {
      newProductObj = state.productsAvailability?.filter(
        (product: ProductAvailabity) =>
          product.productId !== action.product.productId
      );
      newProductObj = [...newProductObj, action.product];
    } else {
      newProductObj = [...newProductObj, action.product];
    }

    ctx.patchState({ productsAvailability: newProductObj });
  }

  @Action(RemoveProductAvailability)
  RemoveProductAvailability(
    ctx: StateContext<ProductsAvailabilityState>,
    action: RemoveProductAvailability
  ): void {
    const state = ctx.getState();
    let newProductObj: ProductAvailabity[] = [];
    if (state.productsAvailability) {
      newProductObj = state.productsAvailability?.filter(
        (product: ProductAvailabity) => product.productId !== action.productId
      );
    }
    if (newProductObj?.length)
      ctx.patchState({ productsAvailability: newProductObj });
    else ctx.patchState({ productsAvailability: null });
  }

  @Action(RemoveAllProductsAvailability)
  RemoveAllProductsAvailability(
    ctx: StateContext<ProductsAvailabilityState>
  ): void {
    ctx.patchState({ productsAvailability: null });
  }

  @Action(SetCarServicesAction)
  setCarServicesAction(
    ctx: StateContext<CarServicesStateModel>,
    action: SetCarServicesAction
  ): void {
    ctx.patchState({
      carServices: action.carServices,
    });
  }
}
